import {useEffect, useState} from "react";

function useFetchableData(fetch, dataName='data') {
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [initialFetch, setInitialFetch] = useState(false);

    const fetchData = () => {
        setLoading(true);
        fetch().then((response) => {
            setData(response.data[dataName]);
            setLoading(false);
            setInitialFetch(true);
        }).catch(function (thrown) {
            console.log('error', thrown.message)
        });
    }

    useEffect(() => {
        fetchData()
    }, [])

    return {data, setData, loading, initialFetch, fetchData};
}

export default useFetchableData;